module.exports = __webpack_public_path__ + "img/bsidd-5.8bf52953.webp";